import { createAction } from '@reduxjs/toolkit';

import type { VideoComment } from 'js/src/client';
import { COMMENTS_ACTIONS } from 'js/src/data/comments/comments-types';

export const storeComments = createAction<{
    comments: VideoComment[];
}>(COMMENTS_ACTIONS.STORE_COMMENTS);

export const clearCommentsBySceneId = createAction<{
    scene_id: string;
}>(COMMENTS_ACTIONS.CLEAR_COMMENTS_BY_SCENE_ID);

export const loadingVideoComments = createAction<{
    status: boolean;
}>(COMMENTS_ACTIONS.LOADING_VIDEO_COMMENTS);

export const addingComment = createAction<{
    status: boolean;
}>(COMMENTS_ACTIONS.ADDING_COMMENT);

export const deletingComment = createAction<{
    status: boolean;
}>(COMMENTS_ACTIONS.DELETING_COMMENT);

export const deletedComment = createAction<{
    comment_id: number;
    scene_id: string | null;
}>(COMMENTS_ACTIONS.DELETED_COMMENT);
